import { FC } from "react";
import { Icon } from "react-migration/components/Icon";
import { useSnapshot } from "valtio";
import { Link } from "react-migration/components/Link";
import { createCompanySearch } from "src/js/view/search/ownership/ownershipSearch/createCompanySearch";
import { BundleId, mapStore } from "src/js/stores/map/store";
import { Company } from "react-migration/domains/ownership/typings/Company";
import { updateMapSettings } from "src/js/stores/map/actions/updateMapSettings";

export type SearchOwnershipLinkProps = SearchableCompany;

export const SearchOwnershipLink: FC<SearchOwnershipLinkProps> = (props) => {
  const { settings } = useSnapshot(mapStore);
  const { mapX, mapY, zoom } = settings;

  return (
    <Link
      to={{
        path: `/legacy-search/${zoom},${mapX},${mapY}`,
        query: {
          activeSearch: BundleId.OWNERSHIP,
          ownership_search: getOwnershipSearch(props),
        },
      }}
    >
      <Icon size="xs" icon="icon-lt-search-line" extraClasses="pointer-events-none" />
    </Link>
  );
};

type SearchableCompany = Pick<Company, "name" | "company_no">;
const getOwnershipSearch = (company: SearchableCompany) => {
  updateMapSettings("activeSearch", BundleId.OWNERSHIP);
  return JSON.stringify(createCompanySearch(company));
};
